import { Button, Menu, MenuItem } from "@mui/material";
import React from "react";
import { SupportedLanguage, supportedLanguages } from "../i18n/config";
import { useUnifiedTranslation } from "../hooks/useUnifiedTranslation";

export const LanguageSwitcher: React.FC = () => {
  const { i18n, changeLanguage } = useUnifiedTranslation();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLanguageChange = async (language: SupportedLanguage) => {
    try {
      await changeLanguage(language);
      handleClose();
    } catch (error) {
      console.error("Failed to change language:", error);
    }
  };

  return (
    <>
      <Button
        color="inherit"
        onClick={handleClick}
        startIcon={
          <span>
            {supportedLanguages[i18n.language as SupportedLanguage]?.flag}
          </span>
        }
      >
        {supportedLanguages[i18n.language as SupportedLanguage]?.name}
      </Button>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
        {Object.entries(supportedLanguages).map(([code, { name, flag }]) => (
          <MenuItem
            key={code}
            onClick={() => handleLanguageChange(code as SupportedLanguage)}
            selected={i18n.language === code}
          >
            <span style={{ marginRight: 8 }}>{flag}</span>
            {name}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};
